import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDBox, FDHeadlineText, FDIcon, FDImage, FDStack, FDTitleText,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const TaxHomeHowItWorks = () => {
  const { resource } = useMetaLayoutContext();
  const howItWorksColl = resource.attr('howItWorks');
  const howItWorks = howItWorksColl?.resources()?.list()?.[0];
  const bullets = howItWorks.attr('bullets')?.resources()?.list();
  const isMobile = useMobileLayout();

  return (
    <FDStack direction="column" spacing={4} paddingX={2} width={'100%'}>
      <FDStack direction="column" spacing={2}>
        <FDHeadlineText size={isMobile ? 'sm' : 'lg'} color="textSecondary" value={howItWorks.attr('title')} />
        <FDBodyText size="md" value={howItWorks.attr('subtitle')} />
      </FDStack>
      <FDStack direction={isMobile ? 'column' : 'row'} wrap spacing={isMobile ? 4 : 10} flex={1}>
        <FDStack direction="column" flex={1} spacing={2.5} maxWidth={'100%'}>
          { bullets.map((bullet, idx) => (
            <HowItWorksRow index={idx} title={bullet?.attr('title')} subtitle={bullet?.attr('subtitles')} />
          ))}
        </FDStack>
        <FDBox alignItems="center" alignSelf="center" flex={1}>
          <FDImage maxWidth={'100%'} alignSelf="center" justifyContent="center" alt="new-planning-technology" src={howItWorks?.attr('imageUrl')} />
        </FDBox>
      </FDStack>
    </FDStack>
  );
};

const HowItWorksRow = ({ index, title, subtitle }) => {
  // maps index to numerical icon (circle1 -- circle3)
  const bulletIcon = `circle${index + 1}`;

  return (
    <FDStack direction="row" alignItems="flex-start" justifyContent="center" spacing={1}>
      <FDBox paddingY={0.25}>
        <FDIcon icon={bulletIcon} />
      </FDBox>
      <FDStack direction="column">
        <FDTitleText size="lg" value={title} />
        <FDBodyText size="md" value={subtitle} />
      </FDStack>
    </FDStack>
  );
};
HowItWorksRow.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export { TaxHomeHowItWorks };
